import { PageRoots, UrlSegments } from './routes';
import { buildPath } from './utils';
// IMPORTANT: If you make breaking changes to any routes,
// remember to add corresponding entries to LEGACY_ROUTES_MAPPING
// this ensures old routes redirect to the new ones, preventing 404 errors
export const portalPaths = {
    root: () => PageRoots.root,
    originalEmail: (id) => buildPath([PageRoots.originalEmail, id]),
    inbox: {
        root: () => buildPath([PageRoots.inbox]),
        selected: (id) => buildPath([PageRoots.inbox, id]),
    },
    conversation: {
        full: (id) => buildPath([PageRoots.conversation, id]),
        allSelected: (id) => buildPath([PageRoots.view, UrlSegments.view.all, 'conversations', id]),
    },
    site: {
        full: (id) => buildPath([PageRoots.site, id]),
        allSelected: (id) => buildPath([PageRoots.view, UrlSegments.view.all, 'sites', id]),
    },
    client: {
        full: (id) => buildPath([PageRoots.client, id]),
        allSelected: (id) => buildPath([PageRoots.view, UrlSegments.view.all, 'clients', id]),
    },
    entity: {
        all: (params) => buildPath([
            PageRoots.view,
            params.customViewId || UrlSegments.view.all,
            params.entityName,
            params.id || '',
        ]),
        selected: (entityName, viewId, recordId = '') => buildPath([PageRoots.view, viewId, entityName, recordId]),
    },
    customView: {
        view: (entityName) => buildPath([PageRoots.views, entityName]),
        action: (entityName, customViewId = 'new') => buildPath([PageRoots.views, entityName, 'update', customViewId]),
    },
    crm: {
        root: () => PageRoots.crm,
        organizations: () => buildPath([PageRoots.crm, UrlSegments.crm.organizations]),
        users: () => buildPath([PageRoots.crm, UrlSegments.crm.users]),
        projects: () => buildPath([PageRoots.crm, UrlSegments.crm.projects]),
    },
    settings: {
        root: () => PageRoots.settings,
        companyInfo: () => buildPath([PageRoots.settings, UrlSegments.settings.companyInfo]),
        memberships: () => buildPath([PageRoots.settings, UrlSegments.settings.memberships]),
        users: () => buildPath([PageRoots.settings, UrlSegments.settings.users]),
        usersDisabled: () => buildPath([
            PageRoots.settings,
            UrlSegments.settings.users,
            UrlSegments.settings.usersDisabled,
        ]),
        usersAssigneeGroups: () => buildPath([
            PageRoots.settings,
            UrlSegments.settings.users,
            UrlSegments.settings.usersAssigneeGroups,
        ]),
        signal: () => buildPath([PageRoots.settings, UrlSegments.settings.signal]),
        workflows: (workflowId, workflowVersionId) => {
            const parts = [PageRoots.settings, UrlSegments.settings.workflows];
            if (workflowId) {
                parts.push(workflowId);
            }
            if (workflowVersionId) {
                parts.push(workflowVersionId);
            }
            return buildPath(parts);
        },
        dataImport: () => buildPath([PageRoots.settings, UrlSegments.settings.dataImport]),
        holidaySchedule: () => buildPath([PageRoots.settings, UrlSegments.settings.holidaySchedule]),
        rulesEngine: () => buildPath([PageRoots.settings, UrlSegments.settings.rulesEngine]),
        rulesEngineUpdateRule: (id) => buildPath([PageRoots.settings, UrlSegments.settings.rulesEngine, id]),
        rulesEngineDisabled: () => buildPath([
            PageRoots.settings,
            UrlSegments.settings.rulesEngine,
            UrlSegments.settings.rulesEngineDisabled,
        ]),
        businessHours: () => buildPath([PageRoots.settings, UrlSegments.settings.businessHours]),
        manageLabels: () => buildPath([PageRoots.settings, UrlSegments.settings.manageLabels]),
        manageCustomAttributes: () => buildPath([PageRoots.settings, UrlSegments.settings.manageCustomAttributes]),
        channels: () => buildPath([PageRoots.settings, UrlSegments.settings.channels]),
        channelsVoice: () => buildPath([
            PageRoots.settings,
            UrlSegments.settings.channels,
            UrlSegments.settings.channelsVoice,
        ]),
        preferences: () => buildPath([PageRoots.settings, UrlSegments.settings.preferences]),
        macros: () => buildPath([PageRoots.settings, UrlSegments.settings.macros]),
        macrosDisabled: () => buildPath([
            PageRoots.settings,
            UrlSegments.settings.macros,
            UrlSegments.settings.macrosDisabled,
        ]),
        macrosUpdate: (id) => buildPath([PageRoots.settings, UrlSegments.settings.macros, id]),
        blockedContacts: () => buildPath([PageRoots.settings, UrlSegments.settings.blockedContacts]),
        stripe: () => buildPath([PageRoots.settings, UrlSegments.settings.stripe]),
        stripeReport: () => buildPath([UrlSegments.settings.stripeReports]),
        signalBusinessHours: () => buildPath([PageRoots.settings, UrlSegments.settings.signalBusinessHours]),
        integrations: () => buildPath([PageRoots.settings, UrlSegments.settings.integrations]),
        integrationsDeveloper: () => buildPath([
            PageRoots.settings,
            UrlSegments.settings.integrations,
            UrlSegments.settings.integrationsDeveloper,
        ]),
    },
    search: (entityName) => buildPath([PageRoots.search, entityName]),
    settingsNotifications: () => buildPath([PageRoots.settings, UrlSegments.settings.notifications]),
    drafts: {
        root: () => buildPath([PageRoots.drafts]),
    },
};
